// Dates and times
export const timeFormat = 'H:mm';

export const shortFullDateFormat = 'D MMM YYYY';
export const shortFullDateTimeFormat = `${shortFullDateFormat} [at] ${timeFormat}`;

export const appName = 'Restaurants';
export const homeUrl = '/analytics';
export const feedbackUrl = 'https://goo.gl/forms/UAhGjPROT13XIUhN2';
export const helpCentreUrl =
  'http://help.deliveroo.com?utm_medium=backlink&utm_source=rx_hub&utm_campaign=help_centre';

export const isServer = typeof window === 'undefined';
